var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-cell-group",class:{ 'm-cell-group--card': _vm.card }},[(_vm.title)?_c('div',{staticClass:"m-cell-group__header"},[_c('div',{staticClass:"m-cell-group__title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("group-suffix")],2):_vm._e(),_c('div',{staticClass:"m-cell__list",class:{ 'is-border': _vm.border }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }